import { MainLayout } from "../layouts";
import { SocialKajian } from "../components";

import { LiputanSection } from "../layouts/HomePage";
import { SejarahSection } from "../components/SejarahCard";

const Sejarah = () => {
  return (
    <MainLayout title={"Sejarah - Dikmen Idrisiyyah"}>
      <div className="flex flex-col lg:flex-row lg:justify-between gap-8 mb-10">
        <SejarahSection />
        <SocialKajian />
      </div>
      <LiputanSection />
    </MainLayout>
  );
};

export default Sejarah;
